import React, { useState } from "react";
import { useAsync } from "react-async-hook";
import { adminCreateService, adminDeleteeService, adminGetAccessGroups, adminGetServices, adminSetService } from "src/app/api/AdminApi";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { AdminService, AdminServiceForm } from "src/domain/AdminService";
import useValidationSchemaService from "src/pages/admin/adminservices/useValidationSchemaService";
import AdminServicesFormContent from "src/pages/admin/adminservices/AdminServicesFormContent";
import styles from "src/pages/admin/adminservices/AdminServicesForm.scss";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";
import { AppSelectOption } from "src/commun/composants/formulaire/AppSelect/AppSelect";
const AdminServicesForm = () => {

  const emptyAdminService: AdminService = {
    id: '',
    code: '',
    url: '',
    urlAffilie: '',
    urlInterne: '',
    urlSubscription: '',
    labelFr: '',
    labelDe: '',
    labelEn: '',
    descriptionFr: '',
    descriptionDe: '',
    descriptionEn: '',
    flagNew: false,
    displayedIfAbsent: false,
    openInNewTab: false,
    rank: 0,
    accessGroups: []
  };



  const services = useAsync(adminGetServices, []);

  const ranks = services.result?.map((service: AdminService) => service.rank);

  const validationSchema = useValidationSchemaService(ranks!);

  const [add, setAdd] = useState(false);
  const accessGroups = useAsync(adminGetAccessGroups, []);

  const submitSuccessHandler = () => {

    services.execute();
  };

  if (services.status === "loading" || accessGroups.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  const mapToAdminServiceForm = (service: AdminService) => {
    return {
      ...service,
      rankInit: service.rank,
      accessGroups: service.accessGroups.map((accessGroup: AdminAccessGroup) => ({
        value: accessGroup.id.toString(),
        label: accessGroup.accessGroup,
      } as AppSelectOption)),
    } as AdminServiceForm;
  };

  const handleSubmitForm = (service: AdminServiceForm) => {
    return adminSetService({
        ...service,

        accessGroups: service.accessGroups.map((accessGroup: AppSelectOption) => ({ id: parseInt(accessGroup.value) } as AdminAccessGroup)),
    } as AdminService);
  };

  const handleSubmitCreateForm = (service: AdminServiceForm) => {
    return adminCreateService({
        ...service,
        accessGroups: service.accessGroups.map((accessGroup: AppSelectOption) => ({ id: parseInt(accessGroup.value) } as AdminAccessGroup)),
    } as AdminService);
  };


  const   onDeleteCreate= () =>{
    setAdd(false)
  }

  const onDeleteCallBack = (service : AdminService) =>{
    return (): void => {
      adminDeleteeService(service).then(()=>{
        submitSuccessHandler();
        setAdd(false)
      }).then(()=>{setAdd(false)})

    };
  }   ;



  return (
    <span className={`ferge-class`}>
      <AppRow>
        <AppCol md={{ span: 12 }}>
            <div className={`${styles.container}`}>
              <h2 className="appTitle">Administrer les services <input onClick={() => setAdd(true)} name="add" value={"+ Ajouter Service "}/> </h2>

              {add &&
                <AppFormik
                  key={"addService"}
                  enableReinitialize
                  initialValues={mapToAdminServiceForm(emptyAdminService)}
                  submitFormAPI={(service: AdminServiceForm) => handleSubmitCreateForm(service)}
                  submitSuccessHandler={submitSuccessHandler}
                  validationSchema={validationSchema}
                >
                  <AdminServicesFormContent
                    accessGroups={(accessGroups.result || []).map(item => ({ value: item.id.toString(), label: item.accessGroup }))}  delete={onDeleteCreate} />
                </AppFormik>
              }

            {(services.result || []).sort((a, b) => a.rank - b.rank).map((service, index) => (
                <AppFormik
                  key={index}
                  enableReinitialize
                  initialValues={mapToAdminServiceForm(service)}
                  submitFormAPI={(service: AdminServiceForm) => handleSubmitForm(service)}
                  submitSuccessHandler={submitSuccessHandler}
                  validationSchema={validationSchema}
                >
                  <AdminServicesFormContent
                    accessGroups={(accessGroups.result || []).map(item => ({ value: item.id.toString(), label: item.accessGroup }))} delete={onDeleteCallBack(service)}/>
                </AppFormik>
              ))}
            </div>
        </AppCol>
      </AppRow>
</span>
  );
};

export default AdminServicesForm;